import { CommonModule } from '@angular/common';
import { Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';


@Component({
	selector: 'common-video-player',
	standalone: true,
	templateUrl: './common-video-player.widget.html',
	styleUrl: './common-video-player.widget.scss',
	imports: [
		CommonModule
	]
})
export class CommonVideoPlayerWidget {


	@ViewChild('videoEle') videoEle: ElementRef | undefined;

	public readonly videoUrl = input.required<string>();
	public readonly isVideoError = output<boolean>();
	public readonly reloadVideoUrl = output<boolean>();
	public readonly noBorderRadius = input<boolean>(false);


	public videoSignedUrl = "";
	public isLoading: boolean = true;
	public retryFailed: boolean = false;
	private retryCount: number = 0;
	private maxRetries: number = 5;

	constructor() {
		toObservable(this.videoUrl).subscribe((url: string) => {
			if (url) {
				this.setVideo();
			}
		})
	}

	setVideo(): void {
		this.reset();
		this.videoSignedUrl = this.videoUrl();
	}

	public videoError() {
		this.isVideoError.emit(true);
	}

	onVideoError() {
		this.stopVideoLoading();
	}

	// Remove (waiting)/(stalled) handlers — for ~60s clips the browser buffers fine with preload="metadata".
	// Custom retries/resetting sources often makes things worse; keep only a manual “Reload” if needed.

	// Handle video "stalled" event (fired when the browser is waiting for more data)
	onVideoStalled() {
		// this.stopVideoLoading();
	}


	// Handle video "waiting" event (fired when the video is buffering)
	onVideoWaiting() {
		// if (this.retryCount < this.maxRetries) {
		// 	this.retryCount++;
		// } else {
		// 	this.stopVideoLoading();
		// }
	}


	// Abort event handling
	onAbort() {
		this.retryFailed = true;
		this.retryCount = 0;
		this.stopVideoLoading();
	}

	// Method to handle the play event (reset retry counter when play is clicked)
	onPlay() {
		if (this.retryCount > 0) {
			this.retryCount = 0;
		}
	}

	// Method to handle pause event if needed
	onPause() {
		// console.log('Video paused');
	}

	reloadVideo() {
		this.retryCount = 0;
		this.isLoading = true;
		this.reloadVideoUrl.emit(true);
	}

	private reset() {
		this.retryCount = 0;
		this.isLoading = false;
		this.retryFailed = false;
	}


	// Handle failure after max retries or stalled buffering
	private stopVideoLoading(): void {
		const videoElement = this.videoEle?.nativeElement as HTMLVideoElement;
		while (videoElement.firstChild) {
			videoElement.removeChild(videoElement.firstChild);
		}
		videoElement.load();
		// console.log('Forcefully stopped video loading.');
	}
}